import React, { useEffect, useState } from "react";
import "./FooterSlide.css";

const FooterSlide = ({ active = false }) => {
  // Google Haritalar embed'i ~397KB JS yükler. Anasayfa Swiper'ında bu slayt başta
  // DOM'da olduğu için loading="lazy" yeterli olmuyor (carousel transform'u nedeniyle
  // tarayıcı "görünür" sayıp yüklüyor). Bu yüzden iframe'i ancak kullanıcı bu slayta
  // ulaşınca mount ediyoruz. Bir kez gösterildikten sonra mount'ta kalır.
  const [showMap, setShowMap] = useState(false);
  useEffect(() => {
    if (active) setShowMap(true);
  }, [active]);

  return (
    <div
      className="footer-slide"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // Ekranın tamamını kapla
        boxSizing: "border-box" // Padding/border dahil et
      }}
    >
      <div className="footer-slide-container">
        {/* 1. Kutu: Konum, iletişim, indirme */}
        <div className="footer-slide-card">
          <h3 className="footer-slide-title">Serdivan Belediyesi Konumu</h3>
          <div className="footer-slide-map">
            {showMap ? (
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1068.2727555346194!2d30.363006322708287!3d40.77232495032057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ccb293e3df9b79%3A0xb1d260fb3d72646b!2sSerdivan%20Belediyesi!5e0!3m2!1str!2str!4v1752048224943!5m2!1str!2str"
                width="100%"
                height="180"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Serdivan Belediyesi Konumu"
              />
            ) : (
              <div
                aria-hidden="true"
                style={{ width: "100%", height: 180, background: "#e9eef3", borderRadius: 8 }}
              />
            )}
          </div>
          
          <h3 className="footer-slide-title">Serdivan Belediye'sine nasıl ulaşırım?</h3>
          <p className="footer-slide-text">
            <a href="tel:4445450" className="footer-slide-link">444 54 50</a> ve <a href="https://wa.me/905316085676" target="_blank" rel="noopener noreferrer" className="footer-slide-link">0531 608 56 76 WhatsApp</a> hattımızdan kolayca iletişim kurabilirsiniz.
          </p>
          
          <h4 className="footer-slide-title">Mobil Uygulamalarımız</h4>
          <div className="footer-slide-badges">
            <a href="https://play.google.com/store/apps/developer?id=Serdivan+Belediyesi&hl=en_ZA" target="_blank" rel="noopener noreferrer">
              <img src="/images/googleplay-badge.webp" alt="Google Play'den indirin" width="160" height="52" loading="lazy" />
            </a>
            <a href="https://apps.apple.com/tr/developer/serdivan-belediyesi/id1529972007" target="_blank" rel="noopener noreferrer">
              <img src="/images/appstore-badge.webp" alt="App Store'dan indirin" width="160" height="52" loading="lazy" />
            </a>
          </div>
        </div>

        {/* 2. Kutu: Bağlantısız, genel bilgiler */}
        <div className="footer-slide-card">
          <h3 className="footer-slide-title">Belediye Hizmetleri</h3>
          <p className="footer-slide-text">
            Belediyemiz; altyapı, temizlik, ruhsat-izin, sosyal hizmetler ve kültürel etkinlikler gibi bir dizi hizmet sunmaktadır. Bu hizmetlere dair genel bilgiler ve yönlendirmeler web sitemizde veya çağrı merkezimiz aracılığıyla sağlanmaktadır.
          </p>

          <h4 className="footer-slide-title">Çalışma Saatleri</h4>
          <p className="footer-slide-text">Hafta içi: 08:30 - 17:30 (resmi tatiller hariç)</p>
        </div>

        {/* 3. Kutu: Sıkça Sorulanlar */}
        <div className="footer-slide-card">
          <h3 className="footer-slide-title">Vergilerimi nasıl ödeyebilirim?</h3>
          <p className="footer-slide-text">
            Anasayfamızdaki <a href="https://webportal.serdivan.bel.tr/" target="_blank" rel="noopener noreferrer" className="footer-slide-link">Hızlı Ödeme</a> butonundan kolayca ödeme yapabilirsiniz.
          </p>
          
          <h3 className="footer-slide-title">Size ilettiğim bir talebi nasıl takip edebilirim?</h3>
          <p className="footer-slide-text">
            Talepleriniz ile ilgili her gelişme ve sonuçlandırma size SMS ile iletilecektir, takip için sizleri ayrıca yormamaktayız :)
          </p>
          
          <h3 className="footer-slide-title">Serdivan Belediyesi'nin duyurularına nasıl ulaşırım?</h3>
          <p className="footer-slide-text">
            Anasayfamızdaki Duyurular butonu üzerinden ulaşabilirsiniz, buradan her türlü ihale, ilan ve genel duyurularımıza göz atabilirsiniz.
          </p>
        </div>
      </div>
      <div
        className="footer-slide-credit"
        style={{ width: "100%", textAlign: "center", marginTop: 20 }}
      >
        © {new Date().getFullYear()} Serdivan Belediyesi Bilgi İşlem Müdürlüğü tarafından geliştirilmiştir
      </div>
    </div>
  );
};

export default FooterSlide;